import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger-menu",
  "use": "icon-hamburger-menu-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14\" id=\"icon-hamburger-menu\">\n    <g fill=\"currentColor\" fill-rule=\"evenodd\">\n        <path d=\"M0 12h18v2H0zM0 6h18v2H0zM0 0h18v2H0z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol